import MyAccountImpl from './my-account.jsx';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * My account modal popup with tabs.
 * It is suitable for usage on desktop only. On mobile we use my-account-page.
 *
 * @class MyAccount
 * @memberof Mojito.Modules.MyAccount
 */

/**
 * My Account prop types.
 *
 * @property {string} [selectedMenuId = ''] - The id of the selected sub tab.
 * @property {string} [onClose = {} => {}] - Callback triggered once may account is getting closed.
 *
 * @memberof Mojito.Modules.MyAccount.MyAccount
 */
const propTypes = {
    selectedMenuId: PropTypes.string,
    onClose: PropTypes.func,
};

const defaultProps = {
    selectedMenuId: '',
    onClose: noop,
};

export default UIView('MyAccount', MyAccountImpl, propTypes, defaultProps);
